(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("sbCommonLib", [], factory);
	else if(typeof exports === 'object')
		exports["sbCommonLib"] = factory();
	else
		root["sbCommonLib"] = factory();
})(window, function() {
return 